// extracted by mini-css-extract-plugin
module.exports = {"ArtistImageWrapper":"Artists_ArtistImageWrapper__3Bagr","ArtistImage":"Artists_ArtistImage__1_Hpb","ArtistDetails":"Artists_ArtistDetails__20rVE"};